export default __webpack_public_path__ + "static/media/library-gold.8d1c6140.svg";